<template>
    <div v-if="isReady">
        <div class="selections" :class="'option-' + selectionType">
            <div class="radio" role="radiogroup" :aria-labelledby="labeledBy">
                <!-- <label v-for="type in selectionTypes" v-bind:key="type.value"
          ><input
            type="radio"
            name="selectionType"
            v-model="selectionType"
            :value="type.value"
            v-on:change="setYearSelectionType"
          />
          <span v-html="type.label"></span>
          </label
        > -->
                <label>
                    <input
                        type="radio"
                        name="selectionType"
                        v-model="selectionType"
                        value="single"
                        v-on:change="setYearSelectionType"
                    />
                    Single Year</label
                >
                <label
                    ><input
                        type="radio"
                        name="selectionType"
                        v-model="selectionType"
                        value="combine"
                        v-on:change="setYearSelectionType"
                    />Combine&nbsp;Years</label
                >
                <label
                    ><input
                        type="radio"
                        name="selectionType"
                        v-model="selectionType"
                        value="compare"
                        v-on:change="setYearSelectionType"
                    />Compare&nbsp;Years</label
                >
            </div>
            <div class="sub-selections">
                <div>
                    <select
                        id="surveyYear"
                        v-if="selectionType === 'single'"
                        v-model="selectedYear"
                        v-focus
                        v-on:change="yearSelected"
                        aria-label="Year"
                    >
                        <option value="0">Select Year</option>
                        <option
                            v-for="year in allYears"
                            v-bind:value="year.year"
                            v-bind:key="year.year"
                        >
                            {{ year.year }}
                        </option>
                    </select>
                </div>
                <div>
                    <multi-year-selection
                        :isEnabled="selectionType === 'combine'"
                    ></multi-year-selection>
                </div>
                <div>
                    <multi-year-selection
                        :isEnabled="selectionType === 'compare'"
                    ></multi-year-selection>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import multiYearSelection from '@/components/multiYearSelection';
import store from '@/store';
import common from '@/scripts/common';

function setYearSelectionType($event) {
    const vm = this;
    store.dispatch('selModel/setYearSelectionType', {
        selectionType: $event.target.value
    });
}

function yearSelected($event) {
    const vm = this;
    store.dispatch('selModel/setYear', {
        selectedYear: common.parsePositiveInt($event.target.value)
    });
}

export default {
    props: ['labeledBy'],
    components: {
        // <my-component> will only be available in parent's template
        'multi-year-selection': multiYearSelection
    },
    created: function () {
        const vm = this;
        const allYears = store.state.dataLists.allYears;
        vm.allYears = allYears;
        vm.isReady = true;
        vm.selectedYear = store.state.selModel.years.single;
        vm.selectionType = store.state.selModel.years.selectionType;
        vm.selectionTypes = [
            { value: 'single', label: 'Single Year' },
            { value: 'combine', label: 'Combine&nbsp;Years' },
            { value: 'compare', label: 'Compare&nbsp;Years' }
        ];
    },
    data: function () {
        return {
            allYears: null,
            store: store,
            isReady: false,
            selectedYear: 0,
            selectionType: '',
            selectionTypes: []
        };
    },
    methods: {
        setYearSelectionType,
        yearSelected,
        getMaxYear: function (allYearsx) {
            const vm = this;
            var maxYear = 0;
            allYearsx.forEach(
                (y) => (maxYear = y.year > maxYear ? y.year : maxYear)
            );
            return maxYear;
        },
        getMinYear: function (allYearsx) {
            var vm = this;
            var minYear = 9999;
            allYearsx.forEach(
                (y) => (minYear = y.year < minYear ? y.year : minYear)
            );
            return minYear;
        }
    }
};
</script>

<style scoped>
/* label {
    box-sizing: border-box !important;
    display: inline-block !important;
    margin: auto !important;
    width: 100% !important;
}
input {
    box-sizing: border-box !important;
    display: inline-block !important;
    margin: auto !important;
    width: 90% !important;
} */
@media only screen and (min-width: 992px) {
    .selections .radio {
        display: flex;
        flex-direction: row;
    }
    .selections .radio label {
        width: 33%;
        line-height: 20px;
    }

    .selections .sub-selections {
        display: flex;
        flex-direction: row;
    }
    .selections .sub-selections > div {
        width: 33%;
        /* padding: 0px 5px 0px 10px; */
        /* box-sizing: content-box; */
    }
    .selections .selection-box,
    .selections select {
        margin-left: 13%;
    }
}

@media only screen and (max-width: 991px) {
    .selections .radio label {
        width: 100%;
        height: 40px;
        display: block;
    }
    .option-single .radio label:nth-child(2) {
        margin-top: 30px;
    }

    /* .selections .sub-selections div:first-child select {
          
  } */

    .sub-selections > div {
        display: none;
    }
    .option-single .sub-selections div:first-child {
        display: block;
        margin-top: -134px;
        margin-bottom: 104px;
        height: 30px;
        z-index: 1;
        position: relative;
        margin-left: 40px;
    }

    .option-combine .radio label:nth-child(3) {
        margin-top: 260px;
    }

    .option-combine .sub-selections div:nth-child(2) {
        display: block;
        margin-top: -320px;
        margin-bottom: 40px;
        height: 280px;
        z-index: 1;
        position: relative;
        margin-left: 40px;
    }

    .option-compare .sub-selections div:nth-child(3) {
        display: block;
        margin-left: 40px;
        margin-top: -20px;
        margin-bottom: 20px;
    }
    /* .selections .radio {
    display: flex;
    flex-direction: column;
  }
  .selections .selection-box {
     margin-left: 15px;
     position: absolute; 
     transform: translate(-10px, 30px);
  } */
}
@media only screen and (max-width: 280px) {
    div.selections > div.sub-selections > div {
        margin-left: 0px !important;
    }
}

.selection-box {
    height: 230px;
    width: 190px;
    overflow-y: auto;
    padding: 0 0 0 0;

    margin-bottom: 20px;
    /*background-color: #f5f5f5;*/
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}

.spaced-out {
    margin-top: 20px;
    margin-bottom: 20px;
}

.radio {
    padding-left: 0;
}

.checkbox,
.radio {
    position: relative;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
}

/* @media only screen and (max-width: 991px) {
    label {
        display: block;
    }
} */
</style>
